module.exports = __webpack_public_path__ + "media/images/emblems/Linden-coat_of_arms-d3b49b854a5ed199ec48ed0c747bfb60.svg";